import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface DmHuyen {
  name: string;
  api_token: string;
}

export interface DmHuyenListInfor {
  errors: unknown;
  dmHuyen: DmHuyen;
  isAuthenticated: boolean;
}

@Module
export default class DmHuyenModule
  extends VuexModule
  implements DmHuyenListInfor
{
  errors = {};
  dmHuyen = {} as DmHuyen;
  isAuthenticated = !!JwtService.getToken();

  get dmHuyens() {
    return this.dmHuyenListData;
  }

  @Mutation
  [Mutations.DM_HUYEN_LIST_DATA](dmHuyens) {
    this.dmHuyenListData = dmHuyens;
  }

  @Action
  [Actions.DM_HUYEN_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("gis/district/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.DM_HUYEN_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.DM_HUYEN_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("gis/district", payload)
        .then((data) => {
          this.context.commit(Mutations.DM_HUYEN_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.DM_HUYEN_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "gis/district",
        payload,
        "delete",
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.DM_HUYEN_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.DM_HUYEN_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("gis/district", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.DM_HUYEN_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  get danhmucHuyenDetail() {
    return this.dmHuyenDetailData;
  }

  @Mutation
  [Mutations.DM_HUYEN_DETAIL_DATA](dmHUyenDetail) {
    this.dmHuyenDetailData = dmHUyenDetail;
  }
  @Action
  [Actions.DM_HUYEN_DETAIL](payload) {
    return ApiService.getDataDetail("/gis/district", payload, "detail", payload)
      .then(({ data }) => {
        this.context.commit(Mutations.DM_HUYEN_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
